import Download from '@mui/icons-material/Download';
import useStyles from './usePlayerButtonStyles.styles';

export type DownloadButtonProps = {
  onClick: () => void;
};

const DownloadButton = ({ onClick } : DownloadButtonProps) => {
  const classes = useStyles();
  return (
    <button
      className={classes.button}
      onClick={onClick}
    >
      <Download />
    </button>
  );
}

export default DownloadButton;